import client from "../libs/HttpClient";

class NewsServices {
  static newsList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/news?page=${page_no}`, request);
  }
  static addNews(request) {
    return client.post(`/add-news`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateNews(request) {
    return client.post(`/edit-news`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewNews(params) {
    return client.get(`get-news`, { params });
  }
  static deleteNews(params) {
    return client.delete(`delete-news`, { params });
  }
}
export { NewsServices };
